import React from "react";
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const TIPO_ALERTA_LABEL = {
  0: "Auto de Infração",
  1: "Nova Mensagem",
  2: "Condicionante",
  3: "Documento Solicitado",
  4: "Pagamento Solicitado",
  5: "Nova Solicitação",
};

const TIPO_ALERTA_COLOR = {
  0: "error",
  1: "info",
  2: "warning",
  3: "secondary",
  4: "success",
  5: "primary",
};

const formatarData = (dataIso) => {
  if (!dataIso) return "";
  try {
    const data = new Date(dataIso);
    if (Number.isNaN(data.getTime())) return "";
    return data.toLocaleString("pt-BR");
  } catch {
    return "";
  }
};

function AlertasModal({ open, onClose, alertas }) {
  const lista = Array.isArray(alertas) ? alertas : [];

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
      >
        Notificações
        <IconButton aria-label="Fechar" onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {lista.length === 0 ? (
          <Typography variant="body2" color="text.secondary" align="center" sx={{ py: 2 }}>
            Nenhuma notificação pendente.
          </Typography>
        ) : (
          <List disablePadding>
            {lista.map((alerta) => {
              const id = alerta.data;
              const tipo = alerta.tipo;
              return (
                <ListItem
                  key={id}
                  alignItems="flex-start"
                  divider
                  sx={{ flexDirection: "column", alignItems: "stretch", gap: 1, py: 1.5 }}
                >
                  <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                    <Chip
                      label={TIPO_ALERTA_LABEL[tipo] ?? "Notificação"}
                      color={TIPO_ALERTA_COLOR[tipo] ?? "default"}
                      size="small"
                    />
                    <Typography variant="caption" color="text.secondary">
                      {formatarData(alerta.createAt)}
                    </Typography>
                  </Stack>
                  <ListItemText primary={alerta.mensagem} />
                </ListItem>
              );
            })}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}

export default AlertasModal;
